import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  currentTab: string = 'All';

  constructor(private router: Router) {}
  
  ngOnInit(): void {
   
  }

  navigateTo(tab: string) {
    this.currentTab = tab;
  }

  goToDetails(playlist: string) {
    this.router.navigate(['/playlist', playlist]);
  }
}